<template>
  <el-container class="wrapper" :class="{'large': isPC, 'small': !isPC}">
    <el-header>
      <home-header></home-header>
    </el-header>
    <el-container class="main-container" style="overflow: auto;">
      <div class="siderbar" :class="{collapse: collapse}">
        <home-side-bar @change="handleCollapse"></home-side-bar>
      </div>
      <div class="content-main">
        <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>
      </div>
    </el-container>
  </el-container>
</template>

<script>
import HomeHeader from './components/HomeHeader'
import HomeSideBar from './components/HomeSideBar'

export default {
  name: 'Home',
  components: {
    HomeHeader,
    HomeSideBar
  },
  data () {
    return {
      isPC: true,
      collapse: false
    }
  },
  mounted () {
    // 尺寸适配
      this.isPC = window.screen.width >= 750
  },
  methods: {
    handleCollapse (collapse) {
      this.collapse = collapse
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/variable.styl'
.wrapper
   background #f6f6f6
   &.large
     position absolute
     top 0px
     bottom 0px
     left 0px
     right 0px
   &.small
     height 2000px
     width 2000px
   .el-header
     padding 0
   .main-container
      display flex
      flex-direction row
      .siderbar
        width 200px
        overflow-y auto
        overflow-x hidden
        background-color $bgSide
        &.collapse
          width 64px
      .content-main
        flex 1
        background-color #fff
        padding 10px 10px
        overflow-y auto
        margin-bottom 10px
        background #f6f6f6
</style>



// WEBPACK FOOTER //
// src/pages/home/Home.vue